<template>
  <video
    ref="video"
    class="t3m-ImageMap-video"
    :src="video.url"
    @timeupdate="track"
  ></video>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "t3mVideo",
  props: {
    url: {
      type: String,
    },
  },
  computed: {
    ...mapState(["video", "status", "selectedHotspot"]),
  },
  mounted() {
    this.$refs.video.classList.add("mounted");
  },
  methods: {
    ...mapActions(["setStatus", "reset"]),
    track: function (e) {
      if (typeof this.selectedHotspot == undefined) {
        return;
      }

      switch (this.status) {
        case "idle":
          this.$refs.video.pause();
          break;
        case "play":
          if (this.selectedHotspot.end <= this.$refs.video.currentTime) {
            this.setStatus("idle");
          }
          break;
        default:
          break;
      }
    },
  },
  watch: {
    status(newValue, oldValue) {
      switch (newValue) {
        case "idle":
          this.$refs.video.pause();
          break;
        case "play":
          this.$refs.video.currentTime = this.selectedHotspot.start;
          this.$refs.video.play();
          break;
        case "reset":
          this.$refs.video.pause();
          this.$refs.video.currentTime = 0;
          this.setStatus("idle")
          break;
        default:
          break;
      }
    },
  },
};
</script>
